export default __webpack_public_path__ + "static/media/NIAS0510.34I-37914_-25182_0.b46207c6.jpg";